import { render } from "./ActionCaptchaModal.vue?vue&type=template&id=704fa6b3&scoped=true"
import script from "./ActionCaptchaModal.vue?vue&type=script&lang=js"
export * from "./ActionCaptchaModal.vue?vue&type=script&lang=js"

import "./ActionCaptchaModal.vue?vue&type=style&index=0&id=704fa6b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704fa6b3"]])

export default __exports__